import React,{useEffect,useState} from 'react';
import {apiRequest,getEntityId,unwrapCollection} from '../../api/client';
import CsvUpload from '../../components/CsvUpload';
import WordForm from '../../components/admin/WordForm';
import WordTable from '../../components/admin/WordTable';

const columns=[
  'front_text',
  'back_text',
  'example_sentence',
  'english_variant',
  'part_of_speech',
  'etymology',
  'target_band',
  'related_forms'
];

function WordsPage() {
  const [words,setWords]=useState([]);
  const [selected,setSelected]=useState(null);
  const [message,setMessage]=useState('');
  const [loading,setLoading]=useState(true);

  const load=async ()=> {
    setLoading(true);

    try {
      const payload=await apiRequest('/flashcards',{auth: false});
      setWords(unwrapCollection(payload,['flashcards','items','results']));
      setMessage('');
    } catch (error) {
      console.error('GET /flashcards failed:',error);
      setMessage(error.message || 'Unable to load words.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(()=> {
    load();
  },[]);

  const save=async (form)=> {
    try {
      await apiRequest(
        selected
          ? `/flashcards/${getEntityId(selected)}`
          : '/flashcards',
        {
          method: selected ? 'PATCH' : 'POST',
          body: JSON.stringify(form)
        }
      );

      setSelected(null);
      setMessage('Word saved successfully.');
      await load();
    } catch (error) {
      console.error('Flashcard save failed:',error);
      setMessage(error.message || 'Unable to save word.');
    }
  };

  const remove=async (word)=> {
    if (!window.confirm(`Delete “${word.front_text}”?`)) {
      return;
    }

    try {
      await apiRequest(`/flashcards/${getEntityId(word)}`,{
        method: 'DELETE'
      });
      await load();
    } catch (error) {
      console.error('DELETE /flashcards failed:',error);
      setMessage(error.message || 'Unable to delete word.');
    }
  };

  const upload=async (rows)=> {
    for (const row of rows) {
      await apiRequest('/flashcards',{
        method: 'POST',
        body: JSON.stringify({
          ...row,
          target_band: Number(row.target_band)
        })
      });
    }

    await load();
  };

  return (
    <section>
      <header className="page-heading">
        <div>
          <span className="eyebrow">Vocabulary library</span>
          <h1>Manage words</h1>
          <p>Add, edit and organize the cards available to students.</p>
        </div>
        <span className="record-count">{words.length} words</span>
      </header>

      {message && <div className="info-banner">{message}</div>}

      <WordForm
        selected={selected}
        onSave={save}
        onCancel={()=> setSelected(null)}
      />

      <CsvUpload columns={columns} onUpload={upload} />

      {loading ? (
        <div className="center-state">
          <span className="loader" />
          Loading words…
        </div>
      ) : (
        <WordTable
          words={words}
          onEdit={setSelected}
          onDelete={remove}
        />
      )}
    </section>
  );
}

export default WordsPage;